// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ab44547","667":"2c8fea5f","977":"19a68214"}[chunkId] + ".chunk.js";
};